import React, { useState } from 'react'
import { CONFIG } from './config'
import styled from 'styled-components'
import { Waypoint } from 'react-waypoint'

/**
 * Component for Scrollytelling
 *
 * Elements for front layer
 * @prop {React.ReactChild[]} front
 *
 * Function returning background layer element
 * index = current visible front layer element
 * @prop {( index:Number )=> React.ReactChild } background
 *
 * gap between the front layer elements as viewport height
 * @prop { Number } distance
 *
 * space after last front element as viewport height
 * @prop { Number } endSpace
 *
 * @returns { React.Element } React Component
 */

export const Scroller = ({
  front,
  back,
  defaultDistance = CONFIG.default.spacerHeight,
  className,
}: {
  front: JSX.Element[]
  back: (e: number, o: { [key: string]: any }) => JSX.Element
  defaultDistance?: number
  className?: string
}) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  return (
    <StyledScroller className={'Scroller ' + className} id='scroller'>
      <div className='back' id='back'>
        {back(currentIndex, front[currentIndex])}
      </div>
      <div className='front'>
        {front.map((element, i) => {
          let dbottom = element.props.distanceBottom || defaultDistance || 1
          let dtop = element.props.distanceTop || defaultDistance || 1
          return (
            <React.Fragment key={'Front_' + i}>
              <Spacer style={{ minHeight: dtop + 'px' }} />
              <Waypoint
                scrollableAncestor={window}
                onEnter={() => setCurrentIndex(i)}
                onLeave={(e) => {
                  let newindex = i + (e.currentPosition === 'below' ? -1 : 1)
                  setCurrentIndex(newindex > 16 ? 16 : newindex)
                }}
              >
                <div>{element}</div>
              </Waypoint>
              <Spacer style={{ minHeight: dbottom + 'px' }} />
            </React.Fragment>
          )
        })}
      </div>
    </StyledScroller>
  )
}

const Spacer = styled.div``
const StyledScroller = styled.div`
  position: relative;
  display: block;
  z-index: 0;
  .back {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    z-index: 0;
    position: sticky;
    top: 0;
  }

  .front {
    -webkit-transform: translate3d(0, 0, 100px);
    transform: translate3d(0, 0, 100px);
    position: relative;
    z-index: 1001;
    width: 100%;
  }
`
